import { connect } from "react-redux";
import flowRight from "lodash.flowright";

//Components
import { EvaluationListWoundTableComponent } from "src/components/tables/evaluation_list_wound_table_component";

//HOC
import {
  withResourceLoaderFactory,
  withLoadingComponentFactory
} from "src/hoc/factories";

//Actions
import {
  loadAssessmentSummariesAction,
  loadWoundRevisionsAction,
  loadWoundSeriesAction
} from "src/actions/data_actions";

import { loadHealingIndexAction } from "src/actions/data_actions/healing_index";
//Constants
import { analyticsEventNames } from "src/constants";

//Selectors
import { createLocalizationDictionarySelectorForAssessmentSummaries } from "src/selectors/section_selectors/global";
import {
  assessmentSummariesResourceSelectors,
  healingIndexResourceSelector
} from "src/selectors/data_selectors";
import { createHealingIndexListContextSelector } from "src/selectors/api_selectors/global/healing_index/create_healing_index_list_context_selector";
import { woundRevisionsResourceSelector } from "src/selectors/data_selectors/wound_revisions";
import { assessmentVersionSelector } from "src/selectors/config_selectors";
import { createFirstPageContextSelector } from "src/selectors/api_selectors/wound_risk/wound/create_first_page_context_selector";
import { createCurrentPageContextSelector } from "src/selectors/api_selectors/wound_risk/wound/create_current_page_context_selector";
import { createCurrentPagePayloadSelector } from "src/selectors/api_selectors/wound_risk/wound/create_current_page_payload_selector";
import { woundRiskSectionSelector } from "src/selectors/section_selectors/wound_risk/wound_risk_wound_selector";
import { woundNumbersEnabledSelector } from "src/selectors/ui_config_selectors/global";
import { woundSeriesResourceSelector } from "src/selectors/data_selectors/wound_series";
import { createWoundSeriesQuerySelector } from "src/selectors/api_selectors/wound_risk/wound_series/create_wound_series_query_selector";
import { createWoundSeriesContextSelector } from "src/selectors/api_selectors/wound_risk/wound_series/create_wound_series_context_selector";
import { createAllPagesPayloadSelector } from "src/selectors/api_selectors/wound_risk/wound_revisions/create_all_pages_payload_selector";
import { createAllPagesContextSelector } from "src/selectors/api_selectors/wound_risk/wound_revisions/create_all_pages_context_selector";
import { createDataForAssessmentSummariesAndHealingIndex } from "src/selectors/data_selectors/healing_index/create_data_for_assessment_summaries_and_healing_index";
import { subtypeKeysForAllSchemasSelector } from "src/selectors/section_selectors/global/subtype_keys_for_all_schemas_selector";

//UI Processors
import SingleValueReduxUtil from "src/ui_processors/single_value";
import { assessmentSummariesResourceActions } from "../../../actions/data_actions";

import { createHealingIndexListQueryForSeriesIdsSelector } from "src/selectors/api_selectors/global/healing_index/create_healing_index_list_query_for_series_ids_selector";

const woundRiskPageLimitSelector = SingleValueReduxUtil.createSelectors(
  "woundRiskPageLimit",
  woundRiskSectionSelector
);

const setWoundRiskPageLimitAction = SingleValueReduxUtil.createActionCreators(
  "woundRiskPageLimit"
);

function mapStateToProps(state) {
  const firstPageContextSelector = createFirstPageContextSelector();
  const assessmentSummaries = createDataForAssessmentSummariesAndHealingIndex()(
    state
  );
  return {
    assessmentSummaries,
    schemaLocalizationDictionary: createLocalizationDictionarySelectorForAssessmentSummaries(
      assessmentSummaries
    )(state),
    totalCount: assessmentSummariesResourceSelectors.createRecordCountSelector(
      createFirstPageContextSelector()
    )(state),
    assessmentVersion: assessmentVersionSelector(state),
    pageLimit: woundRiskPageLimitSelector.fieldSelector(state),
    pageCount:
      assessmentSummariesResourceSelectors.createPageCountSelector(
        firstPageContextSelector,
        woundRiskPageLimitSelector.fieldSelector
      )(state) || 0,
    currentPage: assessmentSummariesResourceSelectors.createCurrentPageForContextSelector(
      firstPageContextSelector
    )(state),
    firstPageContext: firstPageContextSelector(state),
    woundNumbersEnabled: woundNumbersEnabledSelector(state),
    subtypeKeysForSchema: subtypeKeysForAllSchemasSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendSetPageLimitAction: limit => {
      dispatch(setWoundRiskPageLimitAction.setValue(limit));
    },
    sendSetPageAction: (context, pageNumber) => {
      dispatch(
        assessmentSummariesResourceActions.setPageForContextAction(
          context,
          pageNumber
        )
      );
    }
  };
}

export const WoundRiskListTableContainer = flowRight(
  withResourceLoaderFactory({
    getResourceAction: loadWoundSeriesAction,
    resourceSelectors: woundSeriesResourceSelector,
    createContextSelector: createWoundSeriesContextSelector,
    createQuerySelector: createWoundSeriesQuerySelector
  }),
  withResourceLoaderFactory({
    getResourceAction: loadWoundRevisionsAction,
    resourceSelectors: woundRevisionsResourceSelector,
    createContextSelector: createAllPagesContextSelector,
    createPayloadSelector: createAllPagesPayloadSelector,
    waitForParentLoaderToComplete: true
  }),
  withResourceLoaderFactory({
    getResourceAction: loadAssessmentSummariesAction,
    resourceSelectors: assessmentSummariesResourceSelectors,
    createContextSelector: createCurrentPageContextSelector,
    createPayloadSelector: createCurrentPagePayloadSelector,
    waitForParentLoaderToComplete: true
  }),
  withResourceLoaderFactory({
    getResourceAction: loadHealingIndexAction,
    resourceSelectors: healingIndexResourceSelector,
    createContextSelector: createHealingIndexListContextSelector,
    createQuerySelector: createHealingIndexListQueryForSeriesIdsSelector,
    waitForParentLoaderToComplete: true
  }),
  withLoadingComponentFactory({
    analyticsEventName: analyticsEventNames.renderWoundRiskTable
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EvaluationListWoundTableComponent);
